module.exports = __webpack_public_path__ + "img/302.red.f7fc3dfc.gif";